import {Component, Vue} from 'vue-property-decorator';
import AclAccountEntity from '@/entities/AclAccountEntity';

interface LocalStorageState {
    [key: string]: any;
}

@Component
export default class Repository extends Vue {

    private static loadState(): LocalStorageState {
        const json: string | undefined = localStorage.state;
        return json === undefined ? {} : JSON.parse(json);
    }

    private static storeState(state: LocalStorageState): void {
        localStorage.state = JSON.stringify(state);
    }

    public token: string = '';
    public aclAccounts: AclAccountEntity[] = [];

    private readonly storedPropertyNames: string[] = ['token'];

    // noinspection JSUnusedGlobalSymbols
    public created(): void {
        this.localStorageHandler();
        const state = Repository.loadState();
        for (const propertyName of Object.keys(state)) {
            // @ts-ignore
            this[propertyName] = state[propertyName];
        }
    }

    public localStorageHandler(): void {
        for (const propertyName of this.storedPropertyNames) {
            this.$watch(propertyName, (value: any) => {
                const state = Repository.loadState();
                state[propertyName] = value;
                Repository.storeState(state);
            });
        }
        window.console.log(this);
    }
}